<template>
  <TrainingReport />
</template>

<script>
import TrainingReport from '@/components/content/education/training/progress/GroupReport.vue'

export default {
  name: 'TrainingReportPage',
  components: { TrainingReport }
}
</script>

<style scoped>

</style>
